module.exports = __webpack_public_path__ + "static/img/dMRI4.a5aa1fd6.png";